"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fakeData = {
    zoom: 16,
    mapId: 'bmfw-conector-view-map-ol',
    pointsConnectorId: 'bmfw-tooltip-point',
    tooltipPointButtonId: 'bmfw-tooltip-point-button-id',
    parcelName: 'Parcela1',
    tiffUrl: 'https://sentinel-cogs.s3.us-west-2.amazonaws.com/sentinel-s2-l2a-cogs/36/Q/WD/2020/7/S2A_36QWD_20200701_0_L2A/TCI.tif',
    imgDefaultPoint: '',
    centerMapConfig: {
        zoom: 16,
        padding: 30,
        maxZoom: 30,
        animationDuration: 1700,
    },
    polygons: [],
    multiPolygon: 'MULTIPOLYGON(((-1.821353 38.22298, -1.824177 38.2195, -1.82494 38.21941, -1.825722 38.22029, -1.825864 38.22078, -1.826133 38.2215, -1.827 38.22205, -1.827648 38.22283, -1.827973 38.2236, -1.828838 38.2245, -1.82858 38.22537, -1.827637 38.22623, -1.826503 38.22564, -1.822944 38.22444, -1.822114 38.22371, -1.821922 38.22329, -1.821353 38.22298)),((-1.819635 38.22697, -1.815508 38.22902, -1.815416 38.22787, -1.814986 38.22739, -1.813916 38.22714, -1.818113 38.22491, -1.819635 38.22697)),((-1.821972 38.23006, -1.818528 38.22554, -1.819002 38.22516, -1.819825 38.22464, -1.820644 38.22515, -1.821871 38.22518, -1.822997 38.22458, -1.825251 38.22532, -1.827639 38.2262, -1.826947 38.22693, -1.826591 38.22745, -1.82587 38.22792, -1.82481 38.22873, -1.821972 38.23006)),((-1.827458 38.21567, -1.826544 38.21493, -1.827417 38.2148, -1.827835 38.21494, -1.828146 38.21535, -1.828607 38.2151, -1.829149 38.21487, -1.829696 38.21499, -1.830128 38.21519, -1.829943 38.21554, -1.829578 38.21549, -1.828822 38.2154, -1.828674 38.21571, -1.82887 38.21611, -1.828829 38.21654, -1.828954 38.2169, -1.828935 38.21709, -1.828334 38.21668, -1.827816 38.21639, -1.827328 38.21636, -1.827458 38.21567)),((-1.831005 38.21678, -1.83101 38.21661, -1.830137 38.21651, -1.830071 38.21608, -1.83045 38.2158, -1.830771 38.21579, -1.831219 38.21576, -1.830723 38.21557, -1.830897 38.21548, -1.831449 38.21541, -1.83182 38.21547, -1.831747 38.21533, -1.831413 38.21514, -1.831237 38.21491, -1.831161 38.21465, -1.831293 38.21458, -1.831671 38.2151, -1.832048 38.21511, -1.832588 38.21538, -1.833139 38.21544, -1.832947 38.21528, -1.83294 38.21503, -1.833401 38.21537, -1.833547 38.21572, -1.833993 38.21575, -1.834349 38.21593, -1.834505 38.2162, -1.834171 38.21635, -1.833699 38.21628, -1.83313 38.21624, -1.832488 38.21615, -1.831987 38.216, -1.831493 38.2158, -1.831114 38.2163, -1.832013 38.21676, -1.831701 38.21701, -1.831294 38.21706, -1.830983 38.21693, -1.830635 38.21685, -1.831005 38.21678)))',
    points: [
        {
            code: 'ZZADHG',
            info: {
                code: 'ZZADHG',
                level: 'MEDIUM',
                value: 50,
                crop: { id: 163, name: 'Potato', logo_name: 'tuber' },
            },
            coordinates: 'POINT(-1.814986 38.22739)',
            iconUrl: 'images/test_marker.png',
            circleFill: '#008b9b90',
            circleStroke: '#008b9b',
            circleStrokeWidth: 3,
            circleRadius: 17,
            hoverConfig: {
                iconUrl: 'images/test_marker.png',
                circleFill: '#008b9b70',
                circleStroke: '#008b9b',
                circleStrokeWidth: 3,
                circleRadius: 21,
            },
        },
        {
            code: 'ZZADHG',
            info: {
                code: 'ZZADHG',
                level: 'HIGH',
                value: 60,
                crop: { id: 163, name: 'Potato', logo_name: 'bc' },
            },
            coordinates: 'POINT(-1.82481 38.22573)',
            iconUrl: 'images/test_marker.png',
            circleFill: '#6c3fb850',
            circleStroke: '#6c3fb8',
            circleStrokeWidth: 3,
            circleRadius: 17,
            hoverConfig: {
                iconUrl: 'images/test_marker.png',
                circleFill: '#6c3fb850',
                circleStroke: '#6c3fb8',
                circleStrokeWidth: 3,
                circleRadius: 21,
            },
        },
        {
            code: 'ZZAZSS',
            info: {
                code: 'ZZADHG',
                level: 'LOW',
                value: 30,
                crop: { id: 163, name: 'Potato', logo_name: 'banana' },
            },
            coordinates: 'POINT(-1.830723 38.21557)',
            iconUrl: 'images/test_marker.png',
            circleFill: '#008b9b50',
            circleStroke: '#008b9b',
            circleStrokeWidth: 3,
            circleRadius: 17,
            hoverConfig: {
                iconUrl: 'images/test_marker.png',
                circleFill: '#008b9b70',
                circleStroke: '#008b9b',
                circleStrokeWidth: 3,
                circleRadius: 21,
            },
        },
    ],
    projection: {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
    },
    polygonStyle: { stroke: '#1887e4', fill: '#1887e450', strokeWidth: 5 },
};
exports.default = fakeData;
/* MULTIPOLYGON(((-1.821353 38.22298, -1.824177 38.2195, -1.82494 38.21941, -1.825722 38.22029, -1.825864 38.22078, -1.826133 38.2215, -1.827 38.22205, -1.827648 38.22283, -1.827973 38.2236, -1.828838 38.2245, -1.82858 38.22537, -1.827637 38.22623, -1.826503 38.22564, -1.822944 38.22444, -1.822114 38.22371, -1.821922 38.22329, -1.821353 38.22298)),((-1.819635 38.22697, -1.815508 38.22902, -1.815416 38.22787, -1.814986 38.22739, -1.813916 38.22714, -1.818113 38.22491, -1.819635 38.22697)),((-1.821972 38.23006, -1.818528 38.22554, -1.819002 38.22516, -1.819825 38.22464, -1.820644 38.22515, -1.821871 38.22518, -1.822997 38.22458, -1.825251 38.22532, -1.827639 38.2262, -1.826947 38.22693, -1.826591 38.22745, -1.82587 38.22792, -1.82481 38.22873, -1.821972 38.23006)),((-1.827458 38.21567, -1.826544 38.21493, -1.827417 38.2148, -1.827835 38.21494, -1.828146 38.21535, -1.828607 38.2151, -1.829149 38.21487, -1.829696 38.21499, -1.830128 38.21519, -1.829943 38.21554, -1.829578 38.21549, -1.828822 38.2154, -1.828674 38.21571, -1.82887 38.21611, -1.828829 38.21654, -1.828954 38.2169, -1.828935 38.21709, -1.828334 38.21668, -1.827816 38.21639, -1.827328 38.21636, -1.827458 38.21567)),((-1.831005 38.21678, -1.83101 38.21661, -1.830137 38.21651, -1.830071 38.21608, -1.83045 38.2158, -1.830771 38.21579, -1.831219 38.21576, -1.830723 38.21557, -1.830897 38.21548, -1.831449 38.21541, -1.83182 38.21547, -1.831747 38.21533, -1.831413 38.21514, -1.831237 38.21491, -1.831161 38.21465, -1.831293 38.21458, -1.831671 38.2151, -1.832048 38.21511, -1.832588 38.21538, -1.833139 38.21544, -1.832947 38.21528, -1.83294 38.21503, -1.833401 38.21537, -1.833547 38.21572, -1.833993 38.21575, -1.834349 38.21593, -1.834505 38.2162, -1.834171 38.21635, -1.833699 38.21628, -1.83313 38.21624, -1.832488 38.21615, -1.831987 38.216, -1.831493 38.2158, -1.831114 38.2163, -1.832013 38.21676, -1.831701 38.21701, -1.831294 38.21706, -1.830983 38.21693, -1.830635 38.21685, -1.831005 38.21678))) */
/* {
            name: 'Polígono 1',
            color: '#394797',
            fill: '#39479750',
            strokeWidth: 7,
            hoverConfig: {
                colorHover: '#394797',
                fillHover: '#39479750',
                strokeWidthHover: 7,
            },
            info: {
                name: 'Polígono 4',
                extension: 400,
                extensionUnit: 'ha',
                crop: {
                    cropType: 'Maíz',
                    startDate: '2023-06-15',
                    endDate: '2023-10-15',
                },
            },
            coordinates: [
                [-1.821353, 38.22298],
                [-1.824177, 38.2195],
                [-1.82494, 38.21941],
                [-1.825722, 38.22029],
                [-1.825864, 38.22078],
                [-1.826133, 38.2215],
                [-1.827, 38.22205],
                [-1.827648, 38.22283],
                [-1.827973, 38.2236],
                [-1.828838, 38.2245],
                [-1.82858, 38.22537],
                [-1.827637, 38.22623],
                [-1.826503, 38.22564],
                [-1.822944, 38.22444],
                [-1.822114, 38.22371],
                [-1.821922, 38.22329],
                [-1.821353, 38.22298],
            ],
            crop: {
                cropType: 'Trigo',
                startDate: '2023-05-01',
                endDate: '2023-08-31',
            },
        },
        {
            name: 'Polígono 2',
            color: '#f7a800',
            fill: '#f7a80050',
            strokeWidth: 7,
            hoverConfig: {
                colorHover: '#f7a800',
                fillHover: '#f7a80050',
                strokeWidthHover: 7,
            },
            info: {
                name: 'Polígono 4',
                extension: 400,
                extensionUnit: 'ha',
                crop: {
                    cropType: 'Maíz',
                    startDate: '2023-06-15',
                    endDate: '2023-10-15',
                },
            },
            coordinates: [
                [-1.819635, 38.22697],
                [-1.815508, 38.22902],
                [-1.815416, 38.22787],
                [-1.814986, 38.22739],
                [-1.813916, 38.22714],
                [-1.818113, 38.22491],
                [-1.819635, 38.22697],
            ],
            crop: {
                cropType: 'Maíz',
                startDate: '2023-06-01',
                endDate: '2023-09-30',
            },
        },
        {
            name: 'Polígono 3',
            color: '#9d7111',
            fill: '#9d711150',
            strokeWidth: 7,
            hoverConfig: {
                colorHover: '#9d7111',
                fillHover: '#9d711150',
                strokeWidthHover: 7,
            },
            info: {
                name: 'Polígono 4',
                extension: 300,
                extensionUnit: 'ha',
                crop: {
                    cropType: 'Maíz',
                    startDate: '2023-06-15',
                    endDate: '2023-10-15',
                },
            },
            coordinates: [
                [-1.821972, 38.23006],
                [-1.818528, 38.22554],
                [-1.819002, 38.22516],
                [-1.819825, 38.22464],
                [-1.820644, 38.22515],
                [-1.821871, 38.22518],
                [-1.822997, 38.22458],
                [-1.825251, 38.22532],
                [-1.827639, 38.2262],
                [-1.826947, 38.22693],
                [-1.826591, 38.22745],
                [-1.82587, 38.22792],
                [-1.82481, 38.22873],
                [-1.821972, 38.23006],
            ],
            crop: {
                cropType: 'Soja',
                startDate: '2023-07-01',
                endDate: '2023-11-30',
            },
        },
        {
            name: 'Polígono 4',
            color: '#9d7111',
            fill: '#9d711150',
            strokeWidth: 7,
            hoverConfig: {
                colorHover: '#9d7111',
                fillHover: '#9d711150',
                strokeWidthHover: 7,
            },
            info: {
                name: 'Polígono 4',
                extension: 400,
                extensionUnit: 'ha',
                crop: {
                    cropType: 'Maíz',
                    startDate: '2023-06-15',
                    endDate: '2023-10-15',
                },
            },
            coordinates: [
                [-1.827458, 38.21567],
                [-1.826544, 38.21493],
                [-1.827417, 38.2148],
                [-1.827835, 38.21494],
                [-1.828146, 38.21535],
                [-1.828607, 38.2151],
                [-1.829149, 38.21487],
                [-1.829696, 38.21499],
                [-1.830128, 38.21519],
                [-1.829943, 38.21554],
                [-1.829578, 38.21549],
                [-1.828822, 38.2154],
                [-1.828674, 38.21571],
                [-1.82887, 38.21611],
                [-1.828829, 38.21654],
                [-1.828954, 38.2169],
                [-1.828935, 38.21709],
                [-1.828334, 38.21668],
                [-1.827816, 38.21639],
                [-1.827328, 38.21636],
                [-1.827458, 38.21567],
            ],
        },
        {
            name: 'Polígono 5',
            color: '#394797',
            fill: '#39479750',
            strokeWidth: 7,
            hoverConfig: {
                colorHover: '#394797',
                fillHover: '#39479750',
                strokeWidthHover: 7,
            },
            info: {
                name: 'Polígono 4',
                extension: 400,
                extensionUnit: 'ha',
                crop: {
                    cropType: 'Maíz',
                    startDate: '2023-06-15',
                    endDate: '2023-10-15',
                },
            },
            coordinates: [
                [-1.831005, 38.21678],
                [-1.83101, 38.21661],
                [-1.830137, 38.21651],
                [-1.830071, 38.21608],
                [-1.83045, 38.2158],
                [-1.830771, 38.21579],
                [-1.831219, 38.21576],
                [-1.830723, 38.21557],
                [-1.830897, 38.21548],
                [-1.831449, 38.21541],
                [-1.83182, 38.21547],
                [-1.831747, 38.21533],
                [-1.831413, 38.21514],
                [-1.831237, 38.21491],
                [-1.831161, 38.21465],
                [-1.831293, 38.21458],
                [-1.831671, 38.2151],
                [-1.832048, 38.21511],
                [-1.832588, 38.21538],
                [-1.833139, 38.21544],
                [-1.832947, 38.21528],
                [-1.83294, 38.21503],
                [-1.833401, 38.21537],
                [-1.833547, 38.21572],
                [-1.833993, 38.21575],
                [-1.834349, 38.21593],
                [-1.834505, 38.2162],
                [-1.834171, 38.21635],
                [-1.833699, 38.21628],
                [-1.83313, 38.21624],
                [-1.832488, 38.21615],
                [-1.831987, 38.216],
                [-1.831493, 38.2158],
                [-1.831114, 38.2163],
                [-1.832013, 38.21676],
                [-1.831701, 38.21701],
                [-1.831294, 38.21706],
                [-1.830983, 38.21693],
                [-1.830635, 38.21685],
                [-1.831005, 38.21678],
            ],
            crop: {
                cropType: 'Trigo',
                startDate: '2023-05-15',
                endDate: '2023-09-15',
            },
        } */
/*   [
            {
                code: 'ZZADHG',
                info: {
                    code: 'ZZADHG',
                    level: 'MEDIUM',
                    value: 50,
                    crop: { id: 163, name: 'Potato', logo_name: 'tuber' },
                },

                coordinates: 'POINT(-1.814986 38.22739)',
                iconUrl: 'images/test_marker.svg',
                circleFill: '#008b9b90',
                circleStroke: '#008b9b',
                circleStrokeWidth: 3,
                circleRadius: 17,
                hoverConfig: {
                    iconUrl: 'images/test_marker.svg',
                    circleFill: '#008b9b70',
                    circleStroke: '#008b9b',
                    circleStrokeWidth: 3,
                    circleRadius: 21,
                },
            },
            {
                code: 'ZZADHG',
                info: {
                    code: 'ZZADHG',
                    level: 'HIGH',
                    value: 60,
                    crop: { id: 163, name: 'Potato', logo_name: 'bc' },
                },
                coordinates: 'POINT(-1.82481 38.22573)',
                iconUrl: 'images/test_marker.svg',
                circleFill: '#008b9b50',
                circleStroke: '#008b9b',
                circleStrokeWidth: 3,
                circleRadius: 17,
                hoverConfig: {
                    iconUrl: 'images/test_marker.svg',
                    circleFill: '#008b9b70',
                    circleStroke: '#008b9b',
                    circleStrokeWidth: 3,
                    circleRadius: 21,
                },
            },
            {
                code: 'ZZAZSS',
                info: {
                    code: 'ZZADHG',
                    level: 'LOW',
                    value: 30,
                    crop: { id: 163, name: 'Potato', logo_name: 'banana' },
                },
                coordinates: 'POINT(-1.830723 38.21557)',
                iconUrl: 'images/test_marker.svg',
                circleFill: '#008b9b50',
                circleStroke: '#008b9b',
                circleStrokeWidth: 3,
                circleRadius: 17,
                hoverConfig: {
                    iconUrl: 'images/test_marker.svg',
                    circleFill: '#008b9b70',
                    circleStroke: '#008b9b',
                    circleStrokeWidth: 3,
                    circleRadius: 21,
                },
            },
        ]; */
